import React from 'react';
import { InfoboxProps, PushpinProps } from '../../types/MapModels';
import { MapPointKind } from './MapPointKind';
import { TripPlannerContext } from './TripPlannerContext';
import TripPlannerPointPopupContent from './TripPlannerPointPopupContent';
import { colorInput, colorOrigin, colorTarget, toCoords } from './TripPLannerUtils';

export class MapPoint {
    constructor(
        context: TripPlannerContext,
        public location: { latitude: number; longitude: number },
    ) {
        this.id = `tp-${new Date().valueOf()}`;
        this._address = null;
        this.pushpin = {
            location: toCoords(location),
            options: {
                color: colorInput,
            },
        };
        this.infobox = {
            location: this.pushpin.location,
            options: {
                showPointer: true,
                showCloseButton: false,
            },
        };
        this._kind = (-1 as MapPointKind);
        this.setKind(context, MapPointKind.unknown);
    }

    private _kind: MapPointKind;
    private _address: string | null;
    private _hubId: string | null = null;

    public readonly id: string;
    public readonly pushpin: PushpinProps;
    public readonly infobox: InfoboxProps;

    public get kind(): MapPointKind { return this._kind; }
    public get address(): string | null { return this._address; }
    public get hubId(): string | null { return this._hubId; }

    public get showInfobox(): boolean {
        return !!this.address;
    }

    public setLocation(location: { latitude: number; longitude: number }): boolean {
        if (this.location.latitude === location.latitude &&
            this.location.longitude === location.longitude)
            return false;

        this.location = location;
        this.pushpin.location = toCoords(location);
        this.infobox.location = this.pushpin.location;

        return true;
    }

    public updateInfoboxOptions(context: TripPlannerContext) {
        if (this.infobox?.options) {
            this.infobox.title = this.address ?? undefined;
            this.infobox.options.popupAccentColor =
                this._kind === MapPointKind.from
                    ? colorOrigin
                    : this._kind === MapPointKind.to
                        ? colorTarget
                        : undefined;
            this.infobox.text = React.createElement(
                TripPlannerPointPopupContent,
                {
                    kind: this._kind,
                    onSelectFrom: () => context.onPointChoice?.('origin'),
                    onSelectTo: () => context.onPointChoice?.('target'),
                },
            );
            delete this.infobox.options.htmlContent;
            return true;
        }
        return false;
    }

    public setHubId(hubId: string | null): boolean {
        const normalized = hubId || null;
        if (this._hubId === normalized) {
            return false;
        }

        this._hubId = normalized;
        return true;
    }

    public setAddress(context: TripPlannerContext, newValue: string | null): boolean {
        const oldValue = this._address;
        if (oldValue === newValue) return false;

        this._address = newValue;
        if (this.infobox.options) {
            this.updateInfoboxOptions(context);
            // if (!newValue) {
            //     delete this.infobox.options.title;
            // } else {
            //     this.infobox.options.title = newValue;
            // }
        }
        return true;
    }

    public setKind(context: TripPlannerContext, newValue: MapPointKind): boolean {
        if (this._kind === newValue) return false;
        this._kind = newValue;
        if (this.pushpin.options) {
            switch (this._kind) {
                case MapPointKind.unknown:
                    this.pushpin.options.color = colorInput;
                    break;
                case MapPointKind.from:
                    this.pushpin.options.color = colorOrigin;
                    break;
                case MapPointKind.to:
                    this.pushpin.options.color = colorTarget;
                    break;
            }
        }
        return this.updateInfoboxOptions(context);
    }
}
